/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IApi } from "../../api/api";
import { Estimate } from "../../estimate/estimate";
import { Hero } from "./hero";

import "./homePage.scss";

interface IProps {
    api: IApi;
}


export class HomePage extends React.PureComponent<IProps, {}> {
    public render() {
        const { api } = this.props;

        return (
            <div className="scpr-HomePage">
                <div className="scpr-HomePage-hero-container">
                    <div className="hero-text col s8 offset-s1" >
                        <h1 className="hero-type-1">Mow Grass</h1>
                        <h1 className="hero-type-2">Less Problems</h1>
                    </div>

                </div>

                {/*Section 1*/}
                    <div className="section section-1">
                        <div className="row">
                            <div className="col s12 m12">
                                <div className="card-panel col s12 m12 l10 offset-l1 white homeCard">
                                    <div className="col s12 m6 push-m6 l8 push-l4 section1img"></div>
                                    <div className="col s12 m6 pull-m6 l4 pull-l8 homeCardContent">
                                        <h2 >On-Demand <br />Lawn Care</h2>
                                        <h3 >Scaper is an on-demand landscaping service you request right from your phone or computer.</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                {/*Estimate section*/}
                <div className="scpr-HomePage-estimate">
                    <Estimate api={api} />
                </div>

                {/*Section 2*/}
                <div className="section section-2 momlist">
                    <div className="row">
                        <div className="col m9 offset-m1 hailey">
                            <div className="col l6">
                                <h2 className="hero-type-1">Mom's Checklist</h2>
                                <div className="">
                                    <h5><i className="material-icons icon-fix">check_box_outline_blank</i>Wrap birthday gifts</h5>
                                    <h5><i className="material-icons icon-fix">check_box_outline_blank</i>Get the cake</h5>
                                    <h5><i className="material-icons icon-fix">check_box_outline_blank</i>Buy tiki torches</h5>
                                    <h5><i className="material-icons icon-fix">check_box_outline_blank</i><i className="icon-check medium material-icons">check</i><span className="strikeout">Mow the lawn</span></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Section 3*/}
                <div className="section section-3">
                    <h2 className="center-align">Yardwork, minus the work</h2>
                    <div className="row">
                        <div className="col s12 offset-s1 m8 offset-m2 l4">
                            <div className="card col l12">
                                <div className="card-title">
                                    <h2>How it Works</h2>
                                </div>
                                <div className="card-content">
                                    <p>Enter your address to receive an estimate.
                                        Confirm your request.
                                        Take care of life while we cut your grass.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col s12 offset-s1 m8 offset-m2 l4">
                        <div className="card col l12">
                                <div className="card-title">
                                    <h2>Who is a Scaper?</h2>
                                </div>
                                <div className="card-content">
                                    <p>A Scaper is a lawn care provider who has registered with our system.
                                        Scapers can be professional landscapers or entrepreneurs.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col s12 offset-s1 m8 offset-m2 l4">
                        <div className="card col l12">
                                <div className="card-title">
                                    <h2>All in one App</h2>
                                </div>
                                <div className="card-content">
                                    <p>Upfront pricing information.
                                        Secure credit card payment system.
                                        Electronic receipts and records.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/*Section 4*/}
                <div className="section section-5">
                    <div className="row">
                        <div className="col s12 m12">
                            <div className="card-panel col s12 m12 l10 offset-l1 white homeCard">
                                <div className="col s12 m6 l8 section5img"></div>
                                <div className="col s12 m6 l4 homeCardContent">
                                    <h2 >Scapers Wanted!</h2>
                                    <h3 >Own a landscaping business?<br />Scaper expands your customer base by connecting you to nearby homeowners who are actively looking for you.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*never look*/}
                    <div className="row center-align">
                        <h2>Never look for a landscaper again</h2>
                        <h4>contact us at getscaper@gmail.com</h4>
                    </div>
                </div>

            </div>
        );
    }
}
